import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  constructor() {
    this.requestPermission();
  }

  requestPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission !== 'granted') {
          console.warn('Permission for notifications was not granted.');
        }
      });
    }
  }

  showNotification(title: string, body: string) {
    const notification = new Notification(title, {
      body,
      icon: 'assets/images/svg/pin.svg',
      requireInteraction: true,
      tag: Date.now().toString(),
    });

    notification.onclick = (event) => {
      window.focus();
      notification.close();
    };
  }
}
